/**
 * Checks if a date is valid (today or future)
 * @param {Date} date - The date to validate
 * @returns {boolean} - True if date is today or in the future
 */
export const isDateValid = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date >= today;
};

/**
 * Gets the minimum allowed date (today)
 * @returns {Date} - Today's date with time set to 00:00:00
 */
export const getMinDate = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};

/**
 * Checks if a value is empty
 * @param {any} val - The value to check
 * @returns {boolean} - True if value is null, undefined, empty string, or invalid date
 */
export const isEmpty = (val) => {
    if (val === null || val === undefined || val === '') return true;
    // Check if it's an invalid Date object
    if (val instanceof Date && isNaN(val.getTime())) return true;
    return false;
};

/**
 * Parses a date string or Date object to a valid Date or null
 * @param {string|Date} date - The date to parse
 * @returns {Date|null} - Parsed date or null if invalid
 */
export const parseDate = (date) => {
    if (!date) return null;
    if (date instanceof Date) return isNaN(date.getTime()) ? null : date;
    const d = new Date(date);
    return isNaN(d.getTime()) ? null : d;
};

/**
 * Generates field error message
 * @param {boolean} isTouched - Whether field has been touched
 * @param {string} formError - Form error for the field
 * @param {any} value - Field value
 * @param {string} label - Field label for error message
 * @returns {string} - Error message or empty string
 */
export const getFieldError = (isTouched, formError, value, label) => {
    if (!isTouched && !formError) return '';
    if (isEmpty(value)) return `${label} is required`;
    return formError || '';
};

/**
 * Checks if a date value is valid and not empty
 * @param {any} date - The date to check
 * @returns {boolean} - True if date is valid and not empty
 */
export const isDateSet = (date) => {
    if (isEmpty(date)) return false;
    const parsed = parseDate(date);
    return parsed !== null && !isNaN(parsed.getTime());
};